import React from 'react';

import {
  useSelector,
} from 'react-redux';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  Button,
  ContentWrapper,
} from 'web-components';

import {
  Flex,
  Text,
  icons,
  TextBreadcrumbs,
} from 'web-styled';

import * as S from './styled';

const mapState = state => ({
  documents: coreSelectors.getDocuments(
    'library',
  )(state),
});

const ClientDocuments = () => {
  const { documents } = useSelector(mapState);

  return (
    <ContentWrapper
      header={(
        <Flex fillSpace align="center" justify="space-between">
          <TextBreadcrumbs>
            Documents
          </TextBreadcrumbs>
        </Flex>
      )}
    >
      <Flex
        column
        fillSpace
      >
        {documents.length ? documents.map(doc => (
          <S.Item
            key={doc.id}
          >
            <Flex align="center" spacing={10}>
              <S.Name
                as="a"
                rel="noopener noreferrer"
                href={doc.document_file?.url}
                target="_blank"
              >
                <Flex
                  width="16px"
                  height="20px"
                  align="center"
                  justify="center"
                >
                  <S.DocumentIcon />
                </Flex>
                {doc.name}
              </S.Name>
            </Flex>
            <Flex>
              <Button
                as="a"
                rel="noopener noreferrer"
                ghost
                href={doc.document_file?.url}
                target="_blank"
                appearance="primary"
              >
                View document
              </Button>
            </Flex>
          </S.Item>
        )) : (
          <S.Empty>
            <img src={icons.folder} alt="" />
            <Text color="#ccc">
              Nothing to show
            </Text>
          </S.Empty>
        )}
      </Flex>
    </ContentWrapper>
  );
};

export default ClientDocuments;
